import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type MobileTransactionTab = 'all' | 'returned';

interface MobileTransactionTabsProps {
  value: MobileTransactionTab;
  onChange: (value: MobileTransactionTab) => void;
}

const MobileTransactionTabs = ({ value, onChange }: MobileTransactionTabsProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ bgcolor: 'neutral95.main', borderRadius: 2, px: 0.5, pt: 0.5, mb: 2 }}>
      <Tabs
        value={value}
        onChange={(_, next) => onChange(next as MobileTransactionTab)}
        variant="fullWidth"
        sx={{
          minHeight: 0,
          '& .MuiTabs-indicator': { backgroundColor: 'primary.main', height: 3, borderRadius: 1.5 },
          '& .MuiTab-root': {
            minHeight: 0,
            py: 1.75,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '15px',
            color: 'neutral50.main',
          },
          '& .Mui-selected': { color: 'primary.main' },
        }}
      >
        <Tab value="all" label={t('mobileTransactionTabAll', 'All')} />
        <Tab value="returned" label={t('mobileTransactionTabReturned', 'Returned')} />
      </Tabs>
    </Box>
  );
};

export default MobileTransactionTabs;
